// extracted by mini-css-extract-plugin
export default {"backdrop":"NotificationModal_backdrop__6m9jk"};